module.exports = __webpack_public_path__ + "static/media/2.63b5a5ce.jpg";